<template>
  <div class="wrap">
    <v-data-table class="app-table" v-model="selected" :headers="headers" :items="data" :single-select="singleSelect" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer="hide-default-footer" item-key="name" @page-count="pageCount = $event" :no-data-text="$t('common.nodata')">
      <template v-slot:item.status="{ item }"><span>{{ getStatusDisplayWording(item.status) }}</span></template>
    </v-data-table>
    <div class="text-center mt-10">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import { BIKE_STATUS } from '@/libs/enum.js'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: this.$t('tableMaintenance.headers.model'), sortable: false, value: 'model' },
        { text: this.$t('tableMaintenance.headers.description'), sortable: false, value: 'description' },
        { text: this.$t('tableMaintenance.headers.updateAt'), value: 'updateAt' },
        { text: this.$t('tableMaintenance.headers.status'), sortable: false, value: 'status' },
        { text: this.$t('tableMaintenance.headers.frequency'), sortable: false, value: 'frequency' }
      ]
    }
  },
  methods: {
    getStatusDisplayWording (status) {
      const statusKey = BIKE_STATUS[status]
      return this.$t(`deviceStatus.${statusKey}`)
    }
  }
}
</script>
